var map = {
	"./1.webp": 5375,
	"./11.webp": 5438,
	"./2.webp": 6078,
	"./3.webp": 5177,
	"./4.webp": 3856,
	"./5.webp": 9619,
	"./6.webp": 5346,
	"./7.webp": 6685,
	"./8.webp": 628,
	"./9.webp": 9991
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5261;